import { render, staticRenderFns } from "./CWidgetIcon.vue?vue&type=template&id=b9fa0ddc&"
import script from "./CWidgetIcon.vue?vue&type=script&lang=js&"
export * from "./CWidgetIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports